import React from 'react'
import { ArrowShortRightIcon } from '@fourthwall/icons'
import type { ReactElement, ReactNode } from 'react'
import { Icon } from '../Icon'
import * as S from './styled'

export type ActionBarProps = {
  title?: ReactNode
  actionLabel?: string
  icon?: ReactElement
  onClick?: () => void
}

export const ActionBar = ({ title, actionLabel, icon, onClick }: ActionBarProps) => {
  return (
    <S.Container onClick={onClick} data-testid="ActionBar">
      <S.Body>
        {icon ?? icon}
        <span>{title}</span>
      </S.Body>
      <S.ActionLabelContainer>
        <span>{actionLabel}</span>
        <Icon component={ArrowShortRightIcon} height={16} />
      </S.ActionLabelContainer>
    </S.Container>
  )
}
